import request from "library/v1/request";

export function getConversations(params) {
  return request({
    url: 'conversations',
    method: 'get',
    params,
    cancelPrevious: true
  })
}

export function showConversation(id) {
  return request({
    url: `conversations/${id}`,
    method: 'get'
  })
}

export function getMessages(conversationId, params) {
  return request({
    url: `conversations/${conversationId}/messages`,
    method: 'get',
    params,
    cancelPrevious: true
  })
}

export function createMessage(conversationId, data) {
  return request({
    url: `conversations/${conversationId}/messages`,
    method: 'post',
    data
  })
}
